// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"226":"web3-provider","875":"web3modal"}[chunkId] || chunkId) + "." + {"226":"a6a6a6cd","787":"76f73cd1","875":"ada3b49f","948":"b33259e5"}[chunkId] + ".chunk.js";
};